import * as React from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
export default function IosSwitch(props) {
  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      checked={props.checked}
      disableRipple
      {...props}
    />
  ))(({ theme }) => {
    const primaryColor = theme.palette.primary.main;
    const contrastColor = theme.palette.primary.contrastText || "#fff";
    const trackOffColor =
      theme.palette.mode === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700];

    return {
      width: props["width"] ? 42 : 44,
      height: 26,
      padding: 1,
      "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: 2.5,
        transitionDuration: "300ms",
        "&.Mui-checked": {
          transform: "translateX(16px)",
          color: contrastColor,
          "& + .MuiSwitch-track": {
            backgroundColor: primaryColor,
            opacity: 1,
            border: `1px solid ${primaryColor}`,
          },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
          color: primaryColor,
          border: "6px solid #fff",
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
          color:
            theme.palette.mode === "light"
              ? theme.palette.grey[100]
              : theme.palette.grey[600],
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
        },
      },
      "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: props["width"] ? 20 : 22,
        height: props["width"] ? 20 : 22,
      },
      "& .MuiSwitch-track": {
        borderRadius: 26 / 2,
        backgroundColor: trackOffColor,
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
          duration: 500,
        }),
        border: "1px solid #ffffff",
        margin: "-1px",
      },
    };
  });

  return (
    <IOSSwitch
      checked={props.checked}
      onChange={(e) => props.handleChange(e.target.checked)}
    />
  );
}
